/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2021, 2023
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/

import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  messagesAreaTitle: {
    id: 'searchDetailsConfig.messagesAreaTitle',
    defaultMessage: 'Search display text'
  },
  messagesAreaInstructions: {
    id: 'searchDetailsConfig.messagesAreaInstructions',
    defaultMessage: 'Define the text your search will display to the end user'
  },
  successLabel: {
    id: 'searchDetailsConfig.successLabel',
    defaultMessage: 'Message'
  },
  noResultsLabel: {
    id: 'searchDetailsConfig.noResultsLabel',
    defaultMessage: 'No results found'
  },
  connectivityIssueLabel: {
    id: 'searchDetailsConfig.connectivityIssueLabel',
    defaultMessage: 'Connectivity issue'
  },
  customResultsFilter: {
    id: 'searchDetailsConfig.customResultsFilter',
    defaultMessage: 'Custom Results Filter'
  },
  customResultsFilterLabel: {
    id: 'searchDetailsConfig.customResultsFilterLabel',
    defaultMessage:
      'Add the custom text strings to filter the relevant search results.'
  },
  customResultsFilterPlaceholder: {
    id: 'searchDetailsConfig.customResultsFilterPlaceholder',
    defaultMessage: 'Example: enriched_text.entities.text:"Boston, MA"'
  }
});
